<laws-table [hideList]=true>
    <law-new class="row layer px-3 pt-1"
             style="background-color:#efefef;"
             [serviceId]="serviceId"
             [law]="law"
             (formSubmit)="lawsWindowSubmitted($event);"
             (editCancel)="lawsWindowSubmitted($event);">
    </law-new>
</laws-table>